export const PowerMonitor = "PowerMonitor";
export const PQLogger = "PQLogger";

export const CONDITION_MONITORING_IDS = [
  "99341615-91e6-4e15-826a-7a7047a7fa82",
  "9a0a6b89-8fb1-4351-b633-c4f703fc2e56",
  "185ca536-80e5-477f-af64-4a8da05074f7",
  "20ed36da-fc0e-4a66-9fd2-c84870f0ff58",
  "355773a7-edcf-4887-a79e-731c0e179ad1",
  "4381d1b6-13cf-4bc7-88d5-b775cefd127c"
];
export const FCCM_SUPPORTED_LANGUAGES = ["CA", "DE", "GB", "US", "CN"];
export const ASSET_FREE_TRIAL_PURCHASE_OPTIONS = ["CA", "DE", "GB", "US"];
export const FCCM_SUPPORTED_COUNTRIES = [
  "f612e031-dd39-44e6-997c-8eed593befbb",
  "012c0ff6-ae7e-4842-bcd3-1814b5f03005",
  "5d25fb6f-a208-4ce9-8a55-58d7d8af74dc",
  "d18ee457-8ed3-4857-991d-8f47c0da9315",
  "32ec7f9c-db31-45e9-9634-231d6c4d4f6b"
];

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const userConstants = {
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  SOCIAL_LOGIN_ERROR: "SOCIAL_LOGIN_ERROR",
  CANCEL_SOCIAL_LOGIN_FAILURE: "CANCEL_SOCIAL_LOGIN_FAILURE",
  SOCIAL_EMAIL_ALREADY_EXISTS: "SOCIAL_EMAIL_ALREADY_EXISTS",
  ACTIVATE_DEVICE_FLOW: "ACTIVATE_DEVICE_FLOW",

  DATA_SUCCESS: "USERS_DATA_SUCCESS",
  DATA_FAILURE: "USERS_DATA_FAILURE",

  LOGOUT: "USERS_LOGOUT"
};

export const USER_TYPE_CONSTANT = {
  ADMINISTRATOR: {
    NAME: "Administrator",
    ROLE_ID: "66dd3a48-5185-11e3-9430-fbcf1b1a2e9a"
  },
  STANDARD_USER: {
    NAME: "Standard User",
    ROLE_ID: "B5C42396-BC53-11E2-9678-15B654818C3B"
  },
  INDIVIDUAL_USER: {
    NAME: "Individual User",
    ROLE_ID: "B5C423C8-BC53-11E2-9678-15B654818C3B"
  }
};

export const EloquaFormObject = {
  firstName: null,
  lastName: null,
  emailAddress: null,
  businessPhone: null,
  eventComments1: null,
  countryNormalized: "US",
  campaignresponseactivity: "100000000",
  productLineType: "200000000",
  iGBulkEmailOptOut: "FALSE",
  elqFormName: "everythingfc",
  elqSiteId: "1182545284",
  sharedContactList: "4344",
  iGLastReportingProductFamily: "3714FA10-4ECA-E311-BF9F-A4BADB1DDEB4",
  dcUniqueID: null,
  iGLastMSCRMCampaignID: null,
  utmAdGroup: null,
  utmAdName: null,
  utmCampaign: null,
  utmContent: null,
  utmDomain: null,
  utmKW: null,
  utmLP: null,
  utmMedium: null,
  utmSize: null,
  utmSource: null,
  utmTerm: null
};

const eloquaFormPath = "https://s1182545284.t.eloqua.com/e/f2";

export const INVITE_STATUS_IDS = {
  ACCEPTED: "059db816-5167-11e3-9430-fbcf1b1a2e9a",
  DECLINED: "102c88ac-5167-11e3-9430-fbcf1b1a2e9a",
  SENT: "f56b9530-5166-11e3-9430-fbcf1b1a2e9a",
  CANCELLED: "1ccf2808-5167-11e3-9430-fbcf1b1a2e9a"
};

export const activationPopupConstants = {
  SHOW_ACTIAVTION_POPUP: "SHOW_ACTIAVTION_POPUP"
}
